import * as React from "react";
export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 390.704 390.704" {...props}>
    <path d="M379.711 326.556L265.343 212.188c30.826-54.189 23.166-124.495-23.001-170.663-55.367-55.366-145.453-55.366-200.818 0-55.365 55.366-55.366 145.452 0 200.818 46.167 46.167 116.474 53.827 170.663 23.001l114.367 114.369c14.655 14.655 38.503 14.654 53.157 0 14.656-14.654 14.657-38.501 0-53.157zM214.057 214.059c-39.77 39.771-104.479 39.771-144.25 0-39.77-39.77-39.77-104.48 0-144.25 39.771-39.77 104.48-39.77 144.25 0 39.771 39.77 39.77 104.481 0 144.25z" />
  </svg>
);
